export class ServiceOperationResult<T> {
    public error: boolean;
    public data: T;
    
    constructor(error: boolean, data: T) {
        this.error = error;
        this.data = data;
    }
}